import React from 'react';
import { useNavigate } from "react-router-dom";

export const ROUTE = {
	HOME: "/",
	MYDECK: "/mydeck",
	DECKBUILDER: "/deckbuilder",
	CARDSEARCH: "/cardsearch",
	SEARCHSETTING: "/searchsetting",
	OPTION: "/option",
	ACCOUNT: "/account",
	//CARD_DETAIL: '/cards/:id',
	//CARD_DETAIL: (id = ':id') => `/cards/${id}`
};

export const useAppNavigate = () => {
	const navigate = useNavigate();
	return {
		gotoMyDeck: () => navigate(ROUTE.MYDECK),
		gotoDeckBuilder: () => navigate(ROUTE.DECKBUILDER),
		gotoCardSearch: () => navigate(ROUTE.CARDSEARCH),
	};
};
